module.exports = __webpack_public_path__ + "static/media/art_Payment.62117438.jpg";